import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { callback, preloadMfePlugin, startFmpPrefetch, startMfeLoad } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import FeishuSdk from '@ekuaibao/sdk-bridge/sdk/feishu';
import registerAPI from '../registerAPI';
import { initializeTitle } from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { fetchHandleError } from '../FetchConfig';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import { initDatafluxRum } from '../dataflux-rum';
import initLogger from '../../logger/initLogger';
import { localCacheSet } from '@ekuaibao/session-info';
import { anonymousUser, initFeatBit, switchFeatBitUser } from '../../lib/featbit';
import { initializeI18n, setStaffDefaultLanguage } from '../i18n-initialize';
window.__PLANTFORM__ = 'FEISHU';
initDatafluxRum();
initLogger();
function startup(hash) {
    app.use({
        id: '@feishu',
        onready: function () {
            addNcpcCode();
        }
    });
    if (hash) {
        app.useHistory({
            search: location.search.slice(1),
            initialEntries: [hash]
        });
    }
    callback();
}
function modifierKey(e) {
    var modifier = 0;
    if (e.metaKey) {
        modifier |= 1;
    }
    if (e.ctrlKey) {
        modifier |= 2;
    }
    if (e.altKey) {
        modifier |= 4;
    }
    if (e.shiftKey) {
        modifier |= 8;
    }
    return modifier;
}
fetchHandleError();
window.addEventListener('keydown', function (e) {
    var modifier = modifierKey(e);
    if (e.keyCode === 82 && (modifier === 1 || modifier === 2)) {
        window.location.reload();
    }
});
function redirect() {
    var params = (function () {
        var arr = location.search.slice(1).split('&');
        var obj = {};
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('=');
            obj[arr2[0]] = decodeURIComponent(arr2[1]);
        }
        return obj;
    })();
    if (params.roleDefId) {
        localCacheSet('beforePage', 'dimensionMap', true);
        return "/dimension-map?roleDefId=" + params.roleDefId;
    }
    return '';
}
var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                preloadMfePlugin();
                initColors();
                app.container.set('IDeviceType', 'DESKTOP');
                app.container.set('ISMessageEntry', false);
                app.sdk = app.container.get(FeishuSdk);
                registerHandler();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4, Promise.all([
                        initPlatformInfo(),
                        app.sdk.initialize(),
                        initFeatBit(anonymousUser()),
                        initializeI18n()
                    ])];
            case 2:
                _a.sent();
                return [4, switchFeatBitUser()];
            case 3:
                _a.sent();
                return [4, newHomeConfig({ needInitFeatBit: false, needInitI18n: false })];
            case 4:
                _a.sent();
                initRoute();
                startFmpPrefetch();
                startMfeLoad();
                setStaffDefaultLanguage();
                setNetworkAdapter();
                initializeTitle();
                registerAPI();
                return [3, 6];
            case 5:
                e_1 = _a.sent();
                console.error('init error', e_1);
                return [3, 6];
            case 6: return [2];
        }
    });
}); };
var initPromise = null;
export var appDataInitialize = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initPromise = init();
                return [4, initPromise];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
export var bootstrap = function () { return __awaiter(void 0, void 0, void 0, function () {
    var hash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!initPromise) return [3, 2];
                return [4, initPromise];
            case 1:
                _a.sent();
                initPromise = null;
                _a.label = 2;
            case 2:
                hash = redirect();
                return [4, startup(hash)];
            case 3:
                _a.sent();
                return [2];
        }
    });
}); };
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'beta') {
    require('../development');
}
